// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"translations_buttonContainer__B5Faj","modalHelp":"translations_modalHelp__1VylS"};